import { Link } from "react-router-dom";

const REPORT_TYPES = [
  {
    to: "/reports/easy-retail",
    icon: "bi-shop",
    title: "Analisi Easy Retail",
    description:
      "Report inviati da NATPOS sulla cassa: database ISI, bilancia, gap rispetto a Corevian e azioni da fare.",
    badge: "Da NATPOS",
  },
  {
    to: "/reports/vne",
    icon: "bi-cash-coin",
    title: "Collegamento VNE",
    description:
      "Come VNE (cassetto automatico) comunica con Easy Retail sul PC cassa: processi, DB Firebird e codici pagamento.",
    badge: "Da NATPOS",
  },
  {
    to: "/reports/scales",
    icon: "bi-speedometer2",
    title: "Bilance — Scale Gateway",
    description:
      "Diagnostica database WAAGE/Alenia: PLU, totali, integrità, backup e azioni di riparazione inviate da NATPOS.",
    badge: "Da NATPOS",
  },
  {
    to: "/reports/downloads",
    icon: "bi-download",
    title: "Scarica venduto e documenti",
    description:
      "Esporta CSV: venduto, scontrini, fatture e preventivi/documenti non fiscali dal database Corevian.",
    badge: "Export",
  },
];

export default function ReportsHomePage() {
  return (
    <div className="container-fluid py-3">
      <div className="mb-4">
        <h1 className="h4 mb-1">Report</h1>
        <p className="text-muted mb-0 small">
          Archivio report generati dai sistemi collegati a Corevian. I report Easy Retail arrivano automaticamente
          da NATPOS quando premi &quot;Analizza Easy Retail e invia report&quot; sulla cassa.
        </p>
      </div>

      <div className="row g-3">
        {REPORT_TYPES.map((r) => (
          <div key={r.to} className="col-12 col-md-6 col-lg-4">
            <Link to={r.to} className="text-decoration-none text-body">
              <div className="card shadow-sm h-100 report-card-hover">
                <div className="card-body">
                  <div className="d-flex align-items-start gap-3">
                    <div className="rounded-3 bg-light p-2">
                      <i className={`bi ${r.icon} fs-4 text-primary`} />
                    </div>
                    <div>
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <h2 className="h6 mb-0">{r.title}</h2>
                        <span className="badge text-bg-secondary">{r.badge}</span>
                      </div>
                      <p className="small text-muted mb-0">{r.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
